<div class="page-layout carded left-sidebar pt-24">

  <!-- TOP BACKGROUND -->
  <div class="top-bg accent"></div>
  <!-- / TOP BACKGROUND -->


  <!-- CENTER -->
  <div class="center">

    <!-- CONTENT HEADER -->
    <div class="header">
      <p8-settings-header class="am-white" [titlePath]="['Pages']">
        <div>
          <a mat-button title [routerLink]="['new']"><mat-icon>add</mat-icon> Ajouter une page</a>
        </div>
      </p8-settings-header>
    </div>
    <!-- / CONTENT HEADER -->

    <p8-bdc-admin-search-pages class="p-24"></p8-bdc-admin-search-pages>
    <!-- CONTENT CARD -->
    <div class="content-card">
      <!-- CONTENT -->
      <div class="content am-page">
        <div *ngFor="let site of (sites$ | async)">
          <app-tree [parents]="getPagesChildren(site)" (action)="editOrRemovePage(site, $event)" (action2)="getArbo($event)"></app-tree>
          <!--<pre>{{site.pages.children|json}}</pre>-->
        </div>
      </div>
      <!-- / CONTENT -->
    </div>
    <!-- / CONTENT CARD -->

  </div>
  <!-- / CENTER -->

</div>
